// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.opera",
    name: "Opera Crypto Browser",
    homepage: "http://opera.com",
    image_id: "877fa1a4-304d-4d45-ca8e-f76d1a556f00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/itunes-u/id1604311726?action=write-review",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://www.opera.com/crypto/next",
        firefox: "https://www.opera.com/crypto/next",
        safari: "https://www.opera.com/crypto/next",
        edge: "https://www.opera.com/crypto/next",
        opera: "https://www.opera.com/crypto/next",
    },
    rdns: null,
    mobile: {
        native: "cryptobrowser://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map